module.exports = __webpack_public_path__ + "media/fonts/Roboto/Roboto-Regular-31012f9b3e3da44f87e842e419bc267a.woff";